"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var cookie_1 = require("cookie");
var header_field_1 = require("header-field");
var mini_url_1 = require("mini-url");
var statuses = require("statuses");
var Response = /** @class */ (function () {
    /**
     * @description
     * Wrapper around nodejs `ServerResponse`.
     *
     * @param ctx The related Rill Context for the response.
     * @param original The original ServerResponse from rill/http.
     */
    function Response(ctx, original) {
        var _this = this;
        this.ctx = ctx;
        this.original = original;
        this.headers = {};
        this.finished = false;
        this.respond = this.end = true;
        original.once("finish", function () { return (_this.finished = true); });
    }
    /**
     * Utility to retrieve a header from the response headers.
     *
     * @example
     * response.get('Content-Type')
     */
    Response.prototype.get = function (name) {
        return this.headers[header_field_1.normalize(name)];
    };
    /**
     * Utility to overwrite a header on the response headers.
     *
     * @example
     * response.set('Content-Type', 'text/html')
     */
    Response.prototype.set = function (name, value) {
        this.headers[header_field_1.normalize(name)] = value;
    };
    /**
     * Utility to add or set a header on the response headers.
     *
     * @example
     * response.append('Set-Cookie', 'a=1')
     * response.append('Set-Cookie', 'b=1')
     * response.get('Set-Cookie') // -> ['a=1', 'b=1']
     */
    Response.prototype.append = function (name, value) {
        name = header_field_1.normalize(name);
        var headers = this.headers;
        var cur = headers[name];
        if (cur == null) {
            cur = [];
        }
        else if (!Array.isArray(cur)) {
            cur = [cur];
        }
        headers[name] = cur.concat(value);
    };
    /**
     * Utility to remove a header from the response headers.
     *
     * @example
     * response.remove('Content-Type')
     */
    Response.prototype.remove = function (name) {
        delete this.headers[header_field_1.normalize(name)];
    };
    /**
     * Appends to the current set-cookie header, adding a new cookie with options.
     *
     * @example
     * response.cookie('auth-token', 'abc123', { httoOnly: true })
     *
     * @param name - The name of the cookie.
     * @param value - The value for the cookie.
     * @param [options] - Options for the cookie.
     */
    Response.prototype.cookie = function (name, value, options) {
        this.append("Set-Cookie", cookie_1.serialize(name, value, options));
    };
    /**
     * Deletes a cookie from the current set-cookie header.
     *
     * @example
     * response.clearCookie('auth-token')
     */
    Response.prototype.clearCookie = function (name, options) {
        this.append("Set-Cookie", cookie_1.serialize(name, "", tslib_1.__assign({}, options, { expires: new Date() })));
    };
    /**
     * Attaches location headers relative to the current request to perform a redirect.
     * Will redirect to the referrer if "back" is supplied as a url.
     *
     * @example
     * response.redirect('/home') // redirect back to home page.
     */
    Response.prototype.redirect = function (url, alt) {
        var req = this.ctx.req;
        // Back uses request referrer header as a url.
        url = url === "back" ? req.get("Referrer") : url;
        // Default url to alternative.
        url = url || alt;
        if (!url) {
            throw new TypeError("Rill#ctx.res.redirect: Cannot redirect, url not specified and alternative not provided.");
        }
        if (!statuses.redirect[this.status]) {
            this.status = 302;
        }
        this.set("Location", mini_url_1.parse(url, req.href).href);
    };
    /**
     * Attaches refresh headers relative to the current request to perform a timed refresh of the page.
     * Will refresh to the referrer if "back" is supplied as a url.
     *
     * @example
     * response.refresh(2, '/home') // redirect the user home after 2 seconds.
     */
    Response.prototype.refresh = function (delay, url, alt) {
        if (delay === void 0) { delay = 0; }
        var req = this.ctx.req;
        // Back uses request referrer header as a url.
        url = url === "back" ? req.get("Referrer") : url;
        // Default url to alternative.
        url = url || alt || req.href;
        this.set("Refresh", delay + "; url=" + mini_url_1.parse(url, req.href).href);
    };
    return Response;
}());
exports.default = Response;
//# sourceMappingURL=response.js.map